import { render } from "./AccountReorganisationModal.vue?vue&type=template&id=08e8c6eb"
import script from "./AccountReorganisationModal.vue?vue&type=script&lang=js"
export * from "./AccountReorganisationModal.vue?vue&type=script&lang=js"

import "./AccountReorganisationModal.vue?vue&type=style&index=0&id=08e8c6eb&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__